import { EuiBasicTable, EuiButtonIcon, EuiHealth } from "@elastic/eui"
import { useEffect, useState } from "react";
import { formatDateTime } from "../../../../../../shared/utils/fecha";
import { DetalleContent } from "./detalleContent";


export const TablaLogImportaciones = (props:any) =>{

    const {data, onDetalleFilter} = props;

    const [dataTable, setDataTable] = useState<any>([]);
    const [itemIdToExpandedRowMap, setItemIdToExpandedRowMap] = useState<any>({});
    const [sortField, setSortField] = useState('');
    const [sortDirection, setSortDirection] = useState('');
  
    useEffect(()=> setDataTable(data),[data])

    const tWidht = '10%';

    const columns = [
        {
          width: '40px',
          isExpander: true,
          render: (item:any) => item.estado>0 ? (
            <EuiButtonIcon
              className='btn-expand-cell'
              onClick={() => onClickDetalle(item)}
              aria-label={(itemIdToExpandedRowMap && itemIdToExpandedRowMap[item.idImportacion]) ? 'Collapse' : 'Expand'}
              iconType={(itemIdToExpandedRowMap && itemIdToExpandedRowMap[item.idImportacion]) ? 'arrowUp' : 'arrowDown'}
            />
          ) : null,
        },
        {
          field: 'fecha',
          name: 'Fecha',
          sortable: true,
          render: (date: any) => formatDateTime(date),
        },
        {
          field: 'idCentro',
          name: 'IdCentro',
          sortable: true,
          render: (centroId: any) => centroId!==null ? centroId : '',
        },
        {
          field: 'nombre',
          name: 'Nombre',
          sortable: true,
        },
        {
          field: 'estado',
          name: 'Estado',
          sortable: true,
          width: tWidht,
          render: (estado: number) => {
            const color = (estado == 0 ? 'success' : (estado == 1 ? 'danger' : 'warning'));
            const label = (estado == 0 ? 'Correcto' : (estado == 1 ? 'Errores' : 'Avisos'));
            return <EuiHealth color={color}>{label}</EuiHealth>;
          },
        },
      ];

      const onTableChange = ({ sort = {} }) => {
        const { field, direction }:any = sort;
    
        if(direction && direction!=='')
        {
          if(direction === 'desc')
            dataTable.sort((a:any,b:any) => (a[field] > b[field]) ? 1 : ((b[field] > a[field]) ? -1 : 0))
          else
            dataTable.sort((a:any,b:any) => (a[field] < b[field]) ? 1 : ((b[field] < a[field]) ? -1 : 0))
        }
    
        setSortField(field);
        setSortDirection(direction);
      };

      const getDetalle = (item:any)=>{
        const itemIdToExpandedRowMapValues:any = { ...itemIdToExpandedRowMap };
  
        itemIdToExpandedRowMapValues[item.idImportacion] = (
          <DetalleContent item={item} onDetalleFilter={onDetalleFilter}/>
        );
        
        itemIdToExpandedRowMapValues[item.idImportacion] && setItemIdToExpandedRowMap(itemIdToExpandedRowMapValues);
    }
  
    const onClickDetalle = (idObj:any) =>{
      const itemIdToExpandedRowMapValues:any = { ...itemIdToExpandedRowMap };
      const _found = itemIdToExpandedRowMapValues[idObj.idImportacion] ? true : false;
  
      if(_found){
        delete itemIdToExpandedRowMapValues[idObj.idImportacion];
        setItemIdToExpandedRowMap(itemIdToExpandedRowMapValues);
      }else{
        getDetalle(idObj);
      }
    }
  
    const getClassRow = (estado:number) =>{
      switch (estado) {
        case 0: return 'rowSuccess';
        case 1: return 'rowError';
        case 2: return 'rowWarning';
        default: return '';
      }
    }

      const getRowProps = (item:any) => {
        const { idImportacion, estado } = item;
        return {
          'data-test-subj': `row-${idImportacion}`,
          className: getClassRow(estado),
          onClick: () => estado>0 ? onClickDetalle({idImportacion: idImportacion}) : ()=>{},
        };
      };
    
      const sorting:any = {
        sort: {
          field: sortField,
          direction: sortDirection,
        }
      };

    return(
        <EuiBasicTable
            id='tabla-log-importaciones'
            items={data}
            itemId="idImportacion"
            columns={columns}
            rowProps={getRowProps}
            onChange={onTableChange}
            sorting={sorting}
            responsive={true}
            itemIdToExpandedRowMap={itemIdToExpandedRowMap}
            isExpandable={true}
            isSelectable
            noItemsMessage
        />
    )
}